var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function post(url, body, additionalHeaders = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const data = yield fetch(url, {
                headers: Object.assign({ 'content-type': 'application/json' }, additionalHeaders),
                method: 'POST',
                body: JSON.stringify(body),
            }).then((r) => r.json());
            return { data: data, error: null };
        }
        catch (error) {
            return { data: null, error };
        }
    });
}
//# sourceMappingURL=utils.js.map